import React from 'react'
import styles from './leyendas.module.css'

const Leyendas = ({ textCober }) => {
    const renderTextos = () => {
        if (textCober !== undefined && textCober !== null && textCober.length > 0) {
            let textosMap = textCober.map(texto => {
                return [texto.codigoTxtLegal, texto]
            })
            let textosMapArr = new Map(textosMap)
            let textosUnicos = [...textosMapArr.values()]
            let textos = textosUnicos.map(texto => {
                return {
                    valor: texto.detalleTxtLegal,
                    codigoTxtLegal: texto.codigoTxtLegal
                }
            })

            return (
                textos.sort((a, b) => a.codigoTxtLegal - b.codigoTxtLegal).map((texto, index) => (
                    <li key={index}>{texto.valor}</li>
                ))
            )
        } else {
            return null
        }
    }

    return (
        textCober !== undefined &&
        <div className={styles.leyenda}>
            <ol>
                {renderTextos()}
            </ol>
        </div>
    )
}

export default Leyendas